import { createGlobalStyle } from "styled-components";

// Design tokens for the light theme. Brand blue is taken from the logo
// (public/LOGO.png); every text/background pair meets WCAG AA (4.5:1).
const GlobalStyle = createGlobalStyle`
  :root {
    --color-bg: #ffffff;
    --color-bg-subtle: #f6f8fb;
    --color-bg-tint: #f3f6ff;
    --color-surface: #ffffff;
    --color-border: #e4e8ef;
    --color-border-strong: #cdd5e1;

    --color-ink: #0b1324;
    --color-text: #3b4658;
    --color-muted: #5e6b7e;

    --color-primary: #1e44f0;
    --color-primary-hover: #1736c7;
    --color-primary-soft: #edf1ff;
    --color-on-primary: #ffffff;

    --color-success: #15803d;
    --color-success-soft: #ecfdf3;
    --color-danger: #b42318;
    --color-danger-soft: #fef3f2;

    --font-heading: "Outfit", system-ui, -apple-system, "Segoe UI", sans-serif;
    --font-body: "Work Sans", system-ui, -apple-system, "Segoe UI", sans-serif;
    --font-mono: "JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, monospace;

    --radius-sm: 6px;
    --radius: 10px;
    --radius-lg: 16px;

    --shadow-sm: 0 1px 2px rgba(11, 19, 36, 0.05);
    --shadow-md: 0 12px 32px -12px rgba(11, 19, 36, 0.14);
    --shadow-lg: 0 24px 56px -20px rgba(11, 19, 36, 0.22);

    --ease-out: cubic-bezier(0.22, 1, 0.36, 1);
    --nav-height: 72px;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    scroll-behavior: smooth;
    -webkit-text-size-adjust: 100%;
  }

  body {
    font-family: var(--font-body);
    font-size: 1rem;
    line-height: 1.65;
    color: var(--color-text);
    background: var(--color-bg);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  }

  h1,
  h2,
  h3,
  h4 {
    font-family: var(--font-heading);
    font-weight: 600;
    color: var(--color-ink);
    line-height: 1.15;
    letter-spacing: -0.02em;
    text-wrap: balance;
  }

  p {
    text-wrap: pretty;
  }

  img {
    display: block;
    max-width: 100%;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  button,
  input,
  textarea {
    font: inherit;
    color: inherit;
  }

  button {
    cursor: pointer;
  }

  ul {
    list-style: none;
  }

  section[id] {
    scroll-margin-top: var(--nav-height);
  }

  :focus-visible {
    outline: 3px solid var(--color-primary);
    outline-offset: 2px;
  }

  ::selection {
    background: var(--color-primary);
    color: var(--color-on-primary);
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  @media (prefers-reduced-motion: reduce) {
    html {
      scroll-behavior: auto;
    }

    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }
`;

export default GlobalStyle;
